var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chats"},[_c('ticket-message',{attrs:{"message":_vm.ticket}}),_vm._l((_vm.ticket.comments),function(comment,key){return _c('ticket-message',{key:key,attrs:{"message":comment}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }